export enum TIPO_ATRIBUTO {
  TEXTO = 1, //Pode ter subtipo
  INTEIRO = 2, //Pode ter subtipo
  LOGICO = 3,
  TEXTO_MULTIPLO = 4,
  DATA = 5,
  TEMPO = 6,
  DATA_TEMPO = 7,
  DECIMAL = 8
}

export enum SUBTIPO_ATRIBUTO {
  DADO = 1, // Sem subtipo
  ENUM = 2, // Separação por pipe e valor para descrição com igual. Exemplo: 1=Valor 1|2=Valor 2
  API = 3, // Possui informações do API, sendo sempre o primeiro campo o valor de gravação
  GRAPHQL = 4, // Compatibilidade
  IMAGE = 5
}

export interface AtributosDef {
  id: string;
  titulo: string;
  sufixo: string | null;
  descricao: string | null;
  tipo: TIPO_ATRIBUTO | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  subtipo: SUBTIPO_ATRIBUTO | 1 | 2 | 3 | 4 | 5;
  entidade: string;
  entidade_codigo: string;
  valor_padrao: string | null;
  valores: Valores | null;
  obrigatorio: boolean;
  mascara: string | null;
  ordem: number;
  tamanho: number;
  precisao: number;
  multiplo: boolean;
  aceitar_negativo: boolean;
  calculado: boolean;
  deleted_at: string | null;
}

export interface Valores {
  enum: Enum[];
}

export interface Enum {
  text: string;
  value: number;
}
